import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsSensorTypeClearState } from 'reducers/translations/sensorType/reducer'
import SensorTypeList from './SensorTypeList'
import SensorTypeItem from './SensorTypeItem'

function SensorType(props) {
  const {
    match: {
      params: { id },
    },
    translationsSensorTypeClearState,
  } = props
  const SensorTypeContent = id ? SensorTypeItem : SensorTypeList

  useEffect(
    () => () => {
      translationsSensorTypeClearState()
    },
    [],
  )

  return (
    <div className="content">
      <SensorTypeContent {...props} />
    </div>
  )
}

SensorType.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsSensorTypeClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsSensorTypeClearState,
})(SensorType)
